import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { INTERVIEWS_QUERIES } from "~/shared/api/interviews/interviews.queries";
import { JOBS_QUERIES, prefetchJobDetail } from "~/shared/api/jobs/jobs.queries";
import { notFound } from "~/shared/util/notFound";
import { getJobSearchParams, JOB_SETTING_TYPES } from "~/team/search-params/job.search-params";

export async function jobViewLoader({ params, request }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { jobId } = params;

  if (!jobId) {
    return notFound();
  }

  await prefetchJobDetail(jobId, queryClient);

  const url = new URL(request.url);
  const { settings } = getJobSearchParams(url.searchParams);

  if (settings === JOB_SETTING_TYPES.JOB) {
    queryClient.prefetchQuery(JOBS_QUERIES.interviewPlan(jobId));
    queryClient.prefetchQuery(INTERVIEWS_QUERIES.listGlobalInterviewPhases());
  }

  return null;
}
